"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmValues = exports.ConfirmValuesProvider = exports.refundPercentage = void 0;
const react_1 = __importStar(require("react"));
const constants_1 = require("../../../assets/constants/constants");
const storage_1 = require("../../../utils/storage");
const PaymentService_1 = __importDefault(require("../../../services/PaymentService"));
exports.refundPercentage = 0.08;
const ConfirmValuesContext = (0, react_1.createContext)({});
const ConfirmValuesProvider = ({ children }) => {
    const [confirmValues, setConfirmValues] = (0, react_1.useState)(JSON.parse((0, storage_1.getStorageValue)(constants_1.LOCAL_STORAGE.confirmValues) || '{}'));
    const setConfirmValuesOnStorage = (0, react_1.useCallback)((newConfirmValues) => {
        (0, storage_1.setStorageValue)(JSON.stringify(newConfirmValues), constants_1.LOCAL_STORAGE.confirmValues);
        setConfirmValues(newConfirmValues);
    }, []);
    const updateTotalPrice = (0, react_1.useCallback)((couponString, isCheckedRefund) => {
        let refundPrice = 0;
        let newConfirmValues = Object.assign({}, confirmValues);
        if (isCheckedRefund) {
            refundPrice = confirmValues.originalTotalPrice * exports.refundPercentage;
        }
        if (couponString && couponString.trim()) {
            const couponInput = {
                phrase: couponString,
                propId: confirmValues.suite.propId,
                amount: confirmValues.originalTotalPrice,
            };
            const paymentService = new PaymentService_1.default();
            paymentService
                .getCouponDetails(couponInput)
                .then(response => {
                const { couponInfoOutput } = response;
                newConfirmValues = Object.assign(Object.assign({}, newConfirmValues), { totalPrice: Number(couponInfoOutput.totalValueWithDiscount) + refundPrice, cleaningFee: Number(couponInfoOutput.extraAmount), suite: Object.assign(Object.assign({}, newConfirmValues.suite), { cleaningFee: Number(couponInfoOutput.extraAmount) }), coupon: Object.assign(Object.assign({}, couponInfoOutput), { phrase: couponString }), refundPrice,
                    isCheckedRefund });
                setConfirmValuesOnStorage(newConfirmValues);
            })
                .catch(() => {
                newConfirmValues = Object.assign(Object.assign({}, newConfirmValues), { totalPrice: confirmValues.originalTotalPrice + refundPrice, cleaningFee: constants_1.DEFAULT_CLEANING_FEE, suite: Object.assign(Object.assign({}, newConfirmValues.suite), { cleaningFee: constants_1.DEFAULT_CLEANING_FEE }), coupon: {
                        totalValueWithDiscount: `${confirmValues.originalTotalPrice + refundPrice}`,
                        discountValue: '',
                        type: '',
                        extraAmount: '',
                        percentDiscount: '',
                        phrase: '',
                    }, refundPrice,
                    isCheckedRefund });
                setConfirmValuesOnStorage(newConfirmValues);
            });
        }
        else {
            newConfirmValues = Object.assign(Object.assign({}, newConfirmValues), { totalPrice: confirmValues.originalTotalPrice + refundPrice, coupon: undefined, refundPrice,
                isCheckedRefund });
            setConfirmValuesOnStorage(newConfirmValues);
        }
    }, [confirmValues]);
    return (react_1.default.createElement(ConfirmValuesContext.Provider, { value: {
            confirmValues,
            setConfirmValuesOnStorage,
            updateTotalPrice,
        } }, children));
};
exports.ConfirmValuesProvider = ConfirmValuesProvider;
const useConfirmValues = () => (0, react_1.useContext)(ConfirmValuesContext);
exports.useConfirmValues = useConfirmValues;
